import { useMemo, useState } from "react";
import { gql, useQuery } from "@apollo/client";
import { Box } from "@mui/material";
import BasicTabs from "../common/BasicTabs";
import Conversation from "./Conversation";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/auth/authSlice";
import { IRegistrant } from "../../types/registrant";
import { useAppDispatch } from "../../app/hooks";
import { showErrorSnackbar } from "../../features/snackbar/snackbarSlice";
import { IConversation } from "../../types/twilio";

const Conversations = (props: ChildProps) => {
  const storeDispatch = useAppDispatch();
  const { registrant, step, handleCompleteStep } = props;
  const user = useSelector(selectUser);
  const [conversations, setConversations] = useState<IConversation[]>([]);
  const [value, setValue] = useState(0);

  useQuery(GETCONVERSATIONS, {
    variables: { registrant: registrant._id },
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      setConversations(data.getConversations);
    },
    onError: (err) => {
      storeDispatch(showErrorSnackbar("Error getting conversations"));
    },
  });
  
  const tabs = useMemo(() => {
    let tabOptions: any[] = conversations.map((conversation: IConversation) => {
      return {
        label: `${conversation.name}`,
        component: (
          <Conversation
            conversationDetails={conversation}
            messages={conversation.messages}
            selectedUser={user}
            registrant={registrant}
            project={registrant.project.name === conversation.name ? registrant.project : conversation.project ? conversation.project : null}
            step={step} handleCompleteStep={handleCompleteStep}
          />
        ),
      };
    });

    let projectConversation = conversations.some((conversation: IConversation) => {
      return conversation.name.includes(registrant.project.name);
    });

    let userConversation = conversations.some((conversation: IConversation) => conversation.name.includes(user?.fullName!));
    if (!projectConversation) {
      tabOptions.unshift({
        label: `${registrant.project.name}`,
        component: <Conversation conversationDetails={null} messages={[]} project={registrant.project} registrant={registrant} step={step} handleCompleteStep={handleCompleteStep} />,
      });
    }
    if (!userConversation) {
      if (user?.trackingPhone) {
        tabOptions.unshift({
          label: `${user?.fullName!}`,
          component: <Conversation conversationDetails={null} messages={[]} selectedUser={user ? user : null} registrant={registrant} step={step} handleCompleteStep={handleCompleteStep} />,
        });
      }
    }
    return tabOptions;
  }, [conversations, registrant, user]);

  return (
    <Box>
      <BasicTabs color="#00142a" tabs={tabs} sub={false} value={value} setValue={setValue} />
    </Box>
  );
};

interface ChildProps {
  registrant: IRegistrant;
  step?: any;
  handleCompleteStep?: any
}

const GETCONVERSATIONS = gql`
  query getConversations($registrant: MongoID) {
    getConversations(registrant: $registrant) {
      conversationSid
      name
      state
      registrant {
        fullName
      }
      user {
        fullName
        trackingPhone
      }
      project {
        _id
        name
        trackingPhone
      }
      phone
      messages {
        author
        text
        dateCreated
        phone
        direction
      }
    }
  }
`;

export default Conversations;
